import { render, staticRenderFns } from "./CourseBuyMain.vue?vue&type=template&id=558e2eda&scoped=true"
import script from "./CourseBuyMain.vue?vue&type=script&lang=js"
export * from "./CourseBuyMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e2eda",
  null
  
)

export default component.exports